export const TellentHttp = 'tellentHttp';
